// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"747d77e36efb47108e9f5c65a29b49cc","795":"8a4bbda9326d76392d6429ae4a33d608"}[chunkId] + ".js";
};